import { IIconProps } from "../types"

export default function IconLR3(props: IIconProps) {
  const width = props.size || props.width || (94 / 5) * 3
  const height = props.size || props.height || (129 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 94 129"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.1158 0.894236C39.3347 0.154473 41.8339 0.314422 44.693 1.54403C47.5521 2.78363 50.7611 5.08289 56.1294 8.32185C61.4876 11.5708 68.9852 15.7595 74.2535 19.0484C79.5219 22.3374 82.5609 24.7166 85.42 27.4257C88.2791 30.1449 90.9582 33.1839 92.2978 36.2629C93.6373 39.3419 93.6373 42.4609 91.628 53.2674C89.6186 64.074 85.5999 82.5581 82.4309 94.7242C79.252 106.88 76.9327 112.718 74.3835 117.147C71.8443 121.586 69.0752 124.625 64.6066 126.314C60.1381 127.993 53.98 128.323 48.2619 127.754C42.5437 127.174 37.2754 125.694 32.9468 122.165C28.6182 118.626 25.2193 113.038 21.5604 105.401C17.9016 97.7632 13.9629 88.0663 10.7039 79.0692C7.44497 70.0721 4.8558 61.7747 3.16634 54.587C1.46689 47.3993 0.657147 41.3113 0.487202 36.4228C0.307259 31.5344 0.747119 27.8456 2.22664 24.6366C3.69617 21.4277 6.19537 18.7185 10.1741 15.5195C14.1428 12.3106 19.5911 8.61176 24.2796 5.94262C28.9681 3.27347 32.9068 1.634 36.1158 0.894236Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
